import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/newsletter/subscribe?email=${encodeURIComponent(email)}&name=${encodeURIComponent(name)}`, {
        method: 'POST'
      });

      const data = await response.json();
      
      if (response.ok) {
        toast.success(data.message || '¡Suscrito a la newsletter!');
        setEmail('');
        setName('');
      } else {
        toast.error('Error al suscribirse');
      }
    } catch (error) {
      toast.error('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 border-2 border-black rounded">
      <div className="flex items-center gap-2 mb-3">
        <Mail className="w-5 h-5" />
        <h3 className="font-bold text-lg">Newsletter</h3>
      </div>
      <p className="text-sm text-gray-600 mb-4">
        Suscríbete y recibe ofertas exclusivas, consejos y novedades.
      </p>
      <form onSubmit={handleSubmit} className="space-y-3">
        <Input
          type="email"
          placeholder="Tu email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="border-gray-300"
        />
        <Input
          type="text"
          placeholder="Tu nombre (opcional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="border-gray-300"
        />
        <Button 
          type="submit" 
          className="w-full bg-black text-white hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? 'Suscribiendo...' : 'Suscribirse'}
        </Button>
      </form>
      <p className="text-xs text-gray-500 mt-3">
        Puedes darte de baja en cualquier momento.
      </p>
    </div>
  );
}